(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-product-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sticky = document.querySelector('.ph-product-sticky-cta');

    if (!sticky) {
      return;
    }

    document.documentElement.classList.add('ph-has-product-sticky-cta');

    const selectors = [
      'product-form form[action*="/cart/add"]',
      'form[action*="/cart/add"]',
      'product-info',
      '.product__info-container',
      '.product-form'
    ];

    function findProductTarget() {
      for (const selector of selectors) {
        const target = document.querySelector(selector);

        if (target) {
          return target;
        }
      }

      return null;
    }

    function findFocusable(target) {
      if (!target) {
        return null;
      }

      if (target.matches('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')) {
        return target;
      }

      return target.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    }

    sticky.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-ph-product-sticky-scroll]');

      if (!trigger) {
        return;
      }

      event.preventDefault();

      const target = findProductTarget();

      if (!target) {
        return;
      }

      target.scrollIntoView({ behavior: 'smooth', block: 'center' });

      window.setTimeout(() => {
        const focusable = findFocusable(target);

        if (focusable) {
          focusable.focus({ preventScroll: true });
        }
      }, 450);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
